import { render } from "./PCMensajesInformativosPlanificacion.vue?vue&type=template&id=3a8e718e&scoped=true"
import script from "./PCMensajesInformativosPlanificacion.vue?vue&type=script&lang=js"
export * from "./PCMensajesInformativosPlanificacion.vue?vue&type=script&lang=js"

import "./PCMensajesInformativosPlanificacion.vue?vue&type=style&index=0&id=3a8e718e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8e718e"]])

export default __exports__